import React from "react";

// Chakra imports
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <Flex my='32px' h='26px' alignItems='center'>
        <Text
          fontSize='lg'
          fontWeight='700'
          letterSpacing='5px'
          textTransform='uppercase'
          color={logoColor}
        >
          Sparky's{' '}
          <Text as='span' fontWeight='400'>
            API
          </Text>
        </Text>
      </Flex>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
